import componentFromProp from 'recompose/componentFromProp';
import mapProps from 'recompose/mapProps';

import IconBell from 'app/common/icons/IconBell';
import IconEntry from 'app/common/icons/IconEntry';
import IconRate from 'app/common/icons/IconRate';
import IconDinner from 'app/common/icons/IconDinner';


// Соответствие компонентов иконок приложений символьным строкам приложений
const iconsAccords = {
  all: IconBell,
  access: IconEntry,
  dnevnik: IconRate,
  cafeteria: IconDinner,
};

/**
* Контейнер Возвращающий компонет иконки приложения в соответствии символьной строке приложения
* @prop string - символьная строка приложения
*/
const enchance = mapProps(({ string, ...other }) => ({
  component: iconsAccords[string] || IconBell,
  ...other,
}));

const AppIcon = enchance(componentFromProp('component'));

export default AppIcon;
